import { Navigate, Route, Routes } from 'react-router-dom';
import { MainLayout } from '@/components/layouts/MainLayout';
import { RequireSession } from '@/auth/RequireSession';
import { RequireGestor } from '@/auth/RequireGestor';
import { useAuth } from '@/contexts';

// Features
import { HomePage } from '@/features/home';
import { ApuracaoDetalhadaPage } from '@/features/apuracao-detalhada';
import { DocumentosPage } from '@/features/documentos';
import { FornecedoresPage } from '@/features/fornecedores';
import { GestaoImpostosPage } from '@/features/gestao-impostos';
import { ServicosNfsePage } from '@/features/servicos-nfse';
import { RelatoriosPage } from '@/features/relatorios';
import { hasCentralRelatoriosAccess } from '@/features/relatorios/access';
import { ConfiguracoesPage } from '@/features/configuracoes';
import { Login, RecuperarSenha, RedefinirSenha } from '@/features/auth';
import {
  SimplesNacionalLayout,
  GestaoDocumentosPage,
  ApuracaoSNPage,
} from '@/features/simples-nacional';

export function AppRoutes() {
  const { user } = useAuth();
  const canAccessRelatorios = hasCentralRelatoriosAccess(user?.cnpj);

  return (
    <Routes>
      {/* Rotas públicas - sem layout e sem proteção */}
      <Route path="/login" element={<Login />} />
      <Route path="/esqueci-senha" element={<RecuperarSenha />} />
      <Route path="/redefinir-senha" element={<RedefinirSenha />} />

      {/* Rotas protegidas com layout */}
      <Route
        element={
          <RequireSession>
            <RequireGestor>
              <MainLayout />
            </RequireGestor>
          </RequireSession>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/apuracao-detalhada" element={<ApuracaoDetalhadaPage />} />
        {/* Os cartões saíram da home (SPEC-017, decisão 6) e os endereços salvos voltam
            para ela. As telas NÃO foram apagadas: a Apuração por CFOP passa a viver dentro
            da Apuração Detalhada (SPEC-012) e os Cenários esperam decisão da P.O. */}
        <Route path="/apuracao" element={<Navigate to="/" replace />} />
        <Route path="/apuracao-cfop" element={<Navigate to="/" replace />} />
        <Route path="/configuracoes" element={<ConfiguracoesPage />} />
        <Route path="/documentos" element={<DocumentosPage />} />
        <Route path="/fornecedores" element={<FornecedoresPage />} />
        <Route path="/gestao-impostos" element={<GestaoImpostosPage />} />
        <Route path="/servicos-nfse" element={<ServicosNfsePage />} />
        <Route
          path="/relatorios"
          element={canAccessRelatorios ? <RelatoriosPage /> : <Navigate to="/" replace />}
        />

        {/* Simples Nacional */}
        <Route path="/simples-nacional" element={<SimplesNacionalLayout />}>
          <Route index element={<Navigate to="gestao-documentos" replace />} />
          <Route path="gestao-documentos" element={<GestaoDocumentosPage />} />
          <Route path="apuracao" element={<ApuracaoSNPage />} />
          <Route path="*" element={<Navigate to="gestao-documentos" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
